import initSliders from "../components/initSliders.js";
import initLightbox from "../components/initLightbox.js";

document.addEventListener("DOMContentLoaded", () => {

    const {
        initFeaturesSlider,
        initTeamsSlider,
        initHistorySlider
    } = initSliders();

    initFeaturesSlider();
    initTeamsSlider();
    initHistorySlider();

    initLightbox();

});
